/**
 * Зависимости
 */
import MapFilter from 'components/yandex-map/infrastructure-checkbox-filter';
import Observer from '../../common/scripts/observer';
import YandexMap from 'components/yandex-map';

const observer = new Observer();

/**
 * Карта в блоке Расположение
 */
const filterListBtn = document.querySelector('.j-location-filter-list-toggle');
const filterList = document.querySelector('.j-location-infrastructure');
const locationMap = document.querySelector('.j-location-map');
const filterCheckboxToggler = document.querySelector('.j-checkbox-toggle');
const mapFilterWrapper = document.querySelector('.j-map-filter');

if (mapFilterWrapper) {
    const mapFilter = new MapFilter();

    mapFilter.init({target: mapFilterWrapper});

    if (filterCheckboxToggler) {
        observer.subscribe('filterUpdated', () => {
            const togglerText = filterCheckboxToggler.querySelector('span');

            togglerText.innerHTML = mapFilter.globalFilterState ? 'Скрыть' : 'Показать';
        });

        filterCheckboxToggler.addEventListener('click', () => {
            mapFilter.changeCheckBoxState();
        });
    }
}

if (filterListBtn && filterList) {
    filterListBtn.addEventListener('click', () => {
        filterList.classList.toggle('is-open');
        filterListBtn.classList.toggle('is-open');
    });
}

if (locationMap) {
    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            const yandexMap = new YandexMap(ymaps);

            yandexMap.init({
                wrapper                : locationMap,
                cluster                : true,
                fullScreenControl      : true,
                customFullScreenControl: true,
                customZoomControl      : true
            });
        });
    }
}
